// src/api/auth.js
// Single source of truth for the logged-in admin's session. Backed by sessionStorage
// so a page refresh doesn't silently log the user out.
const AUTH_KEY = "honeybuzz_auth";

export const setAuth = (email, password, role) => {
  sessionStorage.setItem(AUTH_KEY, JSON.stringify({ email, password, role }));
};

export const clearAuth = () => {
  sessionStorage.removeItem(AUTH_KEY);
};

const readAuth = () => {
  const raw = sessionStorage.getItem(AUTH_KEY);
  return raw ? JSON.parse(raw) : null;
};

// Axios request-config shape for Basic Auth: {} when logged out, so spreading this
// into any request is always safe.
export const getAuth = () => {
  const stored = readAuth();
  return stored ? { auth: { username: stored.email, password: stored.password } } : {};
};

export const getCurrentUser = () => {
  const stored = readAuth();
  return stored ? { email: stored.email, role: stored.role } : null;
};

export const isAdmin = () => getCurrentUser()?.role === "ADMIN";
